import { put, call, takeLatest } from 'redux-saga/effects'
import { REQUEST_COUPON_DATA } from '../constants/couponConstant'
import { setCouponData, setCouponState } from '../actions/couponAction'

function * requestCouponSaga () {
  let { axios, API } = window
  yield put(setCouponState({ loading: true, errorMessage: '' }))
  let request = () => axios.request({ method: 'post', url: API.Coupon.getCouponList })
  try {
    let data = yield call(request)
    yield put(setCouponData(data))
  } catch (error) {
    yield put(setCouponState({ loading: false, errorMessage: error.message }))
  }
}

export function couponSaga () {
  return takeLatest(REQUEST_COUPON_DATA, requestCouponSaga)
}